import { motion } from "framer-motion";

const orbs = [
  { size: 300, color: "rgba(232, 168, 36, 0.06)", x: "10%", y: "20%", duration: 20 },
  { size: 250, color: "rgba(11, 37, 89, 0.04)", x: "70%", y: "60%", duration: 25 },
  { size: 350, color: "rgba(232, 168, 36, 0.04)", x: "80%", y: "10%", duration: 22 },
  { size: 200, color: "rgba(11, 37, 89, 0.05)", x: "20%", y: "70%", duration: 18 },
];

export default function FloatingOrbs() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {orbs.map((orb, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full blur-3xl"
          style={{
            width: orb.size,
            height: orb.size,
            background: orb.color,
            left: orb.x,
            top: orb.y,
          }}
          animate={{
            x: [0, 30, -20, 15, 0],
            y: [0, -25, 15, -10, 0],
            scale: [1, 1.1, 0.95, 1.05, 1],
          }}
          transition={{
            duration: orb.duration,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
}
